(function initShopTheLookDrawer() {
  if (window.__shopTheLookDrawerBound) return;
  window.__shopTheLookDrawerBound = true;

  function moveDrawerToBody(drawer) {
    if (!drawer || drawer.parentNode === document.body) return drawer;
    document.body.appendChild(drawer);
    return drawer;
  }

  function openDrawer(sectionId) {
    const drawer = moveDrawerToBody(document.querySelector('[data-shop-the-look-drawer="' + sectionId + '"]'));
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('shop-the-look-drawer-open');
  }

  function closeDrawer(sectionId) {
    const drawer = document.querySelector('[data-shop-the-look-drawer="' + sectionId + '"]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.shop-the-look-drawer.is-open')) {
      document.body.classList.remove('shop-the-look-drawer-open');
    }
  }

  document.querySelectorAll('.shop-the-look-drawer').forEach(moveDrawerToBody);

  function closeAllCustomMenus() {
    document.querySelectorAll('[data-shop-the-look-custom-select]').forEach(function(selectWrap) {
      const toggle = selectWrap.querySelector('[data-shop-the-look-custom-toggle]');
      const menu = selectWrap.querySelector('.shop-the-look-item__custom-menu');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    });
  }

  function hideCartError(form) {
    const el = form.querySelector('[data-shop-the-look-cart-error]');
    if (el) {
      el.hidden = true;
      el.textContent = '';
    }
  }

  function showCartError(form, message) {
    const el = form.querySelector('[data-shop-the-look-cart-error]');
    if (el) {
      el.textContent = message || 'Something went wrong. Please try again.';
      el.hidden = false;
    }
  }

  function setSubmitLoading(submitBtn, isLoading) {
    if (!submitBtn) return;
    if (isLoading) {
      submitBtn.dataset.stlSavedHtml = submitBtn.innerHTML;
      submitBtn.innerHTML = '<span class="loading-spinner" style="--loading-spinner-size:22px" aria-hidden="true"></span>';
      submitBtn.classList.add('shop-the-look-item__submit--loading');
      submitBtn.setAttribute('aria-busy', 'true');
    } else {
      submitBtn.classList.remove('shop-the-look-item__submit--loading');
      submitBtn.removeAttribute('aria-busy');
      if (submitBtn.dataset.stlSavedHtml != null) {
        submitBtn.innerHTML = submitBtn.dataset.stlSavedHtml;
        delete submitBtn.dataset.stlSavedHtml;
      }
    }
  }

  function getStlSizeValueOrder(item) {
    const el = item.querySelector('[data-shop-the-look-size-order]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function buildStlSelectedOptions(item, optionCount, skipIndex) {
    const selected = new Array(optionCount).fill('');
    item.querySelectorAll('[data-shop-the-look-option-default]').forEach(function(input) {
      const idx = Number(input.dataset.optionIndex);
      if (Number.isInteger(idx) && idx >= 0 && idx < optionCount && idx !== skipIndex) {
        selected[idx] = input.value;
      }
    });
    item.querySelectorAll('[data-shop-the-look-option-select]').forEach(function(sel) {
      const idx = Number(sel.dataset.optionIndex);
      if (!Number.isInteger(idx) || idx < 0 || idx >= optionCount || idx === skipIndex) return;
      selected[idx] = sel.value;
    });
    return selected;
  }

  function variantMatchesStlSelection(variant, selected, sizeIdx) {
    if (!variant || !variant.options) return false;
    for (let i = 0; i < selected.length; i += 1) {
      if (i === sizeIdx) continue;
      if (!selected[i]) return false;
      if (variant.options[i] !== selected[i]) return false;
    }
    return true;
  }

  /**
   * Rebuild Size native + custom options from variant matrix (mirrors PDP dynamic availability for other options).
   */
  function rebuildStlSizeOptions(item) {
    const sizeSelect = item.querySelector('select[data-shop-the-look-option-name="Size"]');
    const variantsJsonEl = item.querySelector('[data-shop-the-look-variants]');
    if (!sizeSelect || !variantsJsonEl) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!variants.length || !variants[0].options) return;

    const optionCount = variants[0].options.length;
    const sizeIdx = Number(sizeSelect.dataset.optionIndex);
    if (!Number.isInteger(sizeIdx) || sizeIdx < 0) return;

    const selected = buildStlSelectedOptions(item, optionCount, sizeIdx);
    const allowed = {};
    variants.forEach(function(v) {
      if (variantMatchesStlSelection(v, selected, sizeIdx) && v.options[sizeIdx]) {
        allowed[v.options[sizeIdx]] = true;
      }
    });

    const order = getStlSizeValueOrder(item);
    const sizeValues = [];
    order.forEach(function(s) {
      if (allowed[s]) sizeValues.push(s);
    });
    Object.keys(allowed).forEach(function(s) {
      if (sizeValues.indexOf(s) === -1) sizeValues.push(s);
    });

    const placeholderText = sizeSelect.getAttribute('data-stl-size-placeholder') || 'Select a size';
    const prev = sizeSelect.value;

    sizeSelect.innerHTML = '';
    const ph = document.createElement('option');
    ph.value = '';
    ph.textContent = placeholderText;
    sizeSelect.appendChild(ph);
    sizeValues.forEach(function(s) {
      const opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      sizeSelect.appendChild(opt);
    });

    if (prev && sizeValues.indexOf(prev) !== -1) {
      sizeSelect.value = prev;
    } else {
      sizeSelect.value = '';
    }

    const customWrap = sizeSelect.nextElementSibling;
    if (customWrap && customWrap.matches('[data-shop-the-look-custom-select]')) {
      const label = customWrap.querySelector('[data-shop-the-look-custom-label]');
      const menu = customWrap.querySelector('.shop-the-look-item__custom-menu');
      const selOpt = sizeSelect.options[sizeSelect.selectedIndex];
      if (label) {
        label.textContent = selOpt && selOpt.value ? selOpt.textContent.trim() : placeholderText;
      }
      if (menu) {
        menu.innerHTML = '';
        sizeValues.forEach(function(s) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'shop-the-look-item__custom-option';
          btn.setAttribute('data-shop-the-look-custom-option', '');
          btn.dataset.value = s;
          btn.textContent = s;
          menu.appendChild(btn);
        });
      }
    }
  }

  function updateItemVariant(item) {
    const hiddenVariantInput = item.querySelector('[data-shop-the-look-variant-id]');
    const submitBtn = item.querySelector('[data-shop-the-look-submit]');
    const sizeError = item.querySelector('[data-shop-the-look-size-error]');
    if (!hiddenVariantInput || !submitBtn) return;

    const variantsJsonEl = item.querySelector('[data-shop-the-look-variants]');
    if (!variantsJsonEl) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent || '[]');
    } catch (e) {
      variants = [];
    }
    if (!variants.length) return;

    const optionCount = Array.isArray(variants[0].options) ? variants[0].options.length : 0;
    const selectedOptions = new Array(optionCount).fill('');

    item.querySelectorAll('[data-shop-the-look-option-default]').forEach(function(input) {
      const idx = Number(input.dataset.optionIndex);
      if (Number.isInteger(idx) && idx >= 0 && idx < optionCount) selectedOptions[idx] = input.value;
    });

    item.querySelectorAll('[data-shop-the-look-option-select]').forEach(function(sel) {
      const idx = Number(sel.dataset.optionIndex);
      if (Number.isInteger(idx) && idx >= 0 && idx < optionCount) selectedOptions[idx] = sel.value;
    });

    const hasUnselectedOption = selectedOptions.some(function(value) { return !value; });
    if (hasUnselectedOption) {
      hiddenVariantInput.value = '';
      hiddenVariantInput.disabled = true;
      submitBtn.textContent = submitBtn.dataset.defaultLabel || 'Select a size';
      submitBtn.dataset.addToCartText = submitBtn.textContent;
      submitBtn.disabled = false;
      if (sizeError) sizeError.hidden = true;
      return;
    }

    const matchedVariant = variants.find(function(variant) {
      if (!variant || !variant.options) return false;
      for (let i = 0; i < selectedOptions.length; i += 1) {
        if (variant.options[i] !== selectedOptions[i]) return false;
      }
      return true;
    });

    if (!matchedVariant) {
      hiddenVariantInput.value = '';
      hiddenVariantInput.disabled = true;
      submitBtn.textContent = submitBtn.dataset.defaultLabel || 'Select a size';
      submitBtn.dataset.addToCartText = submitBtn.textContent;
      submitBtn.disabled = false;
      if (sizeError) sizeError.hidden = true;
      return;
    }

    hiddenVariantInput.value = matchedVariant.id;
    hiddenVariantInput.disabled = false;

    if (matchedVariant.available) {
      submitBtn.textContent = 'Add to cart';
      submitBtn.dataset.addToCartText = submitBtn.textContent;
      submitBtn.disabled = false;
      if (sizeError) sizeError.hidden = true;
    } else {
      submitBtn.textContent = 'Out of stock';
      submitBtn.disabled = true;
      if (sizeError) sizeError.hidden = true;
    }
  }

  document.addEventListener('click', function(evt) {
    const customToggle = evt.target.closest('[data-shop-the-look-custom-toggle]');
    if (customToggle) {
      evt.preventDefault();
      const wrap = customToggle.closest('[data-shop-the-look-custom-select]');
      if (!wrap) return;
      const menu = wrap.querySelector('.shop-the-look-item__custom-menu');
      const isOpen = customToggle.getAttribute('aria-expanded') === 'true';
      closeAllCustomMenus();
      if (menu && !isOpen) {
        customToggle.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }
      return;
    }

    const customOption = evt.target.closest('[data-shop-the-look-custom-option]');
    if (customOption) {
      evt.preventDefault();
      const wrap = customOption.closest('[data-shop-the-look-custom-select]');
      const item = customOption.closest('.shop-the-look-item');
      if (!wrap || !item) return;

      const nativeSelect = wrap.previousElementSibling;
      const label = wrap.querySelector('[data-shop-the-look-custom-label]');
      if (!nativeSelect || !nativeSelect.matches('[data-shop-the-look-option-select]')) return;

      nativeSelect.value = customOption.dataset.value || '';
      if (label) label.textContent = customOption.textContent.trim();
      closeAllCustomMenus();
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const openBtn = evt.target.closest('[data-shop-the-look-open]');
    if (openBtn) {
      evt.preventDefault();
      openDrawer(openBtn.getAttribute('data-shop-the-look-open'));
      return;
    }

    const closeBtn = evt.target.closest('[data-shop-the-look-close]');
    if (closeBtn) {
      evt.preventDefault();
      closeDrawer(closeBtn.getAttribute('data-shop-the-look-close'));
      return;
    }

    closeAllCustomMenus();
  });

  document.addEventListener('keydown', function(evt) {
    if (evt.key !== 'Escape') return;
    document.querySelectorAll('.shop-the-look-drawer.is-open').forEach(function(drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('shop-the-look-drawer-open');
  });

  document.addEventListener('change', function(evt) {
    const select = evt.target.closest('[data-shop-the-look-option-select]');
    if (!select) return;
    const item = select.closest('.shop-the-look-item');
    if (!item) return;
    const sizeError = item.querySelector('[data-shop-the-look-size-error]');
    if (sizeError) sizeError.hidden = true;
    hideCartError(item.querySelector('.shop-the-look-item__form'));

    var sizeSelect = item.querySelector('select[data-shop-the-look-option-name="Size"]');
    var changedIdx = Number(select.dataset.optionIndex);
    var sizeIdx = sizeSelect ? Number(sizeSelect.dataset.optionIndex) : -1;
    if (sizeSelect && Number.isInteger(sizeIdx) && changedIdx !== sizeIdx) {
      rebuildStlSizeOptions(item);
    }

    updateItemVariant(item);
  });

  document.addEventListener('submit', function(evt) {
    const form = evt.target.closest('.shop-the-look-item__form');
    if (!form) return;
    const hiddenVariantInput = form.querySelector('[data-shop-the-look-variant-id]');
    evt.preventDefault();

    hideCartError(form);

    const hasOptionSelectors = !!hiddenVariantInput;
    const variantNotReady = hasOptionSelectors && (hiddenVariantInput.disabled || !hiddenVariantInput.value);
    if (variantNotReady) {
      const submitBtn = form.querySelector('[data-shop-the-look-submit]');
      if (submitBtn) {
        submitBtn.textContent = submitBtn.dataset.defaultLabel || 'Select a size';
      }
      const sizeError = form.querySelector('[data-shop-the-look-size-error]');
      if (sizeError) sizeError.hidden = false;
      return;
    }

    const submitBtn = form.querySelector('[data-shop-the-look-submit]');
    if (submitBtn) {
      submitBtn.dataset.previousText = submitBtn.dataset.addToCartText || submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      setSubmitLoading(submitBtn, true);
    }

    const formData = new FormData(form);
    const variantId = formData.get('id');
    if (!variantId) {
      setSubmitLoading(submitBtn, false);
      if (submitBtn) {
        submitBtn.textContent = submitBtn.dataset.defaultLabel || 'Select a size';
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
      }
      return;
    }

    function restoreSubmitAfterSuccess() {
      setTimeout(function() {
        if (submitBtn) {
          setSubmitLoading(submitBtn, false);
          submitBtn.textContent = submitBtn.dataset.previousText || 'Add to cart';
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
        }
      }, 1200);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            var msg = 'Could not add to cart. Please try again.';
            if (data) {
              if (typeof data.description === 'string') msg = data.description;
              else if (typeof data.message === 'string') msg = data.message;
              else if (data.errors && typeof data.errors === 'object') {
                var parts = [];
                Object.keys(data.errors).forEach(function(k) {
                  var v = data.errors[k];
                  if (Array.isArray(v)) parts.push(v.join(', '));
                  else if (v) parts.push(String(v));
                });
                if (parts.length) msg = parts.join(' ');
              }
            }
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function() {
        setSubmitLoading(submitBtn, false);
        if (submitBtn) {
          submitBtn.textContent = 'Added to cart';
        }
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        if (typeof theme !== 'undefined' && theme.settings && theme.settings.afterAddToCart === 'drawer') {
          var cartDrawer = document.querySelector('.js-cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }
        restoreSubmitAfterSuccess();
      })
      .catch(function(err) {
        setSubmitLoading(submitBtn, false);
        showCartError(form, err && err.message ? err.message : 'Could not add to cart. Please try again.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
        }
      });
  });

  document.querySelectorAll('.shop-the-look-item').forEach(function(item) {
    rebuildStlSizeOptions(item);
    updateItemVariant(item);
  });
})();
